require("./UI/skipWinsButton.js");
require("../../node_modules/hammerjs/hammer.min.js");
require("../../libs/reflex-library/src/lib/shape.js");
require("./pixi-spine.js");
require("../../libs/reflex-library/src/lib/gsap.min.js");
require("./LoaderController.js");
require("./game.js");
require("./helperFunctions.js");
require("./gameController.js");
require("./spinController.js");
require("./ParticleController.js");
require("./spineSymbolAnimator.js");
require("./symbolAnimator.js");
require("./fancyGroupRules.js");
require("./anticpationRule.js");
require("./Feature/FreeSpins/freespinsController.js");
require("./Feature/FreeSpins/FreeSpinsSpinButtonComponent.js");
require("./Feature/FreeSpins/FreeSpinsSkipButtonComponent.js");
require("./Feature/FreeSpins/FreeSpinsDialogView.js");
require("./GameHelpers.js");
require("../../libs/reflex-library/src/lib/screenDimObject.js");
require("../../libs/reflex-library/src/lib/screenshotAnimator.js");
require("./SymbolWinBorderAnimController.js");
require("./AudioController.js");
require("./ShowReelView.js");
require("./UI/GameSlamStopButtonComponent.js");
require("./BigWinController.js");
require("../../libs/reflex-library/src/lib/colourBox.js");
require("./UI/LuckyBetToggleController.js");
require("./Feature/FreeSpins/FreeSpinsMeterComponent.js");
require("../../libs/reflex-library/src/lib/spine.js");
require("./MessagePopperView.js");
require("./UI/StakeMinusButtonComponent.js");
require("./UI/StakePlusButtonComponent.js");
require("./MessageBoxController.js");
require("./WinTextController.js");
require("./BuyBonus/BuyBonusButtonComponent.js");
require("./BuyBonus/BuyBonusPopupView.js");
require("./UI/SettingsMenuController.js");
require("./UI/SettingsMenuButtonComponent.js");
require("./Animations/BackgroundAnimsView.js");
require("./ReelSpinnerVisual.js");
require("./winAnimations/movieSymbolAnimator.js");
require("./winAnimations/royalSymbolAnimator.js");
require("./winAnimations/SymbolLandAnimator.js");
require("./winlineAnimator.js");
require("./CoinsView.js");
require("./CloverRespins.js");
require("./GoldenSpins.js");
require("./PrizePots.js");
require("./SmallWinController.js");
require("../../libs/reflex-library/src/lib/gsapPixiPlugin.js");
require("./MotionPathPlugin.js");
require("./ScrollContainer.js");

//Setting Menu Buttons
require("./SystemSettings/SystemSettingsButtonComponent.js");
require("./SystemSettings/SystemSettingsCloseComponent.js");
require("./SystemSettings/SystemSettingsIntroScreenButtonComponent.js");
require("./SystemSettings/SystemSettingsSoundsComponents.js");
require("./SystemSettings/systemTotalBet.js");
require("./UI/settingSound.js");
require("./SystemSettings/SystemSettingsBoxView.js");
require("./SoundManager.js");

//Stake/Bet Menu
require("./StakeSettings/stakeSelectionPopup_ext.js");

//Autoplay
require("./AutoplaySettings/autoplayManager-ext.js");

//Menubar
require("./SideMenu/SideMenuCloseComponent.js");
require("./GameRecoveryController.js");

//require("./ReelSpinnerData.js");

require("./CoinCollection.js");

require("./SmartTweens.js");
